module.exports = __webpack_public_path__ + "media/src/assets/share_boat_1-d79e9cd118ba4da26060ebeed2c1ef27.png";